<template>
    <div class="v-icon mr-2 ">
        <v-dialog
            :value="editPersonVehicleDialog"
            max-width="500px"
            persistent
        >
            <v-card>
                <v-card-title
                    class="pt-1 pb-1 headline grey lighten-2"
                    color="primary"
                    primary-title
                >
                    <span class="headline">Edit Vehicle</span>
                    <v-spacer />
                    <v-btn
                        @click="toggleEditDialog()"
                        fab
                        small
                        text
                    >
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex
                                md6
                                sm6
                                xs12
                            >
                                <v-text-field
                                    :error-messages="editRegistrationNumberErrors"
                                    @blur="$v.editRegistrationNumber.$touch()"
                                    @input="$v.editRegistrationNumber.$touch()"

                                    label="Registration Number"
                                    type="text"
                                    v-model="editRegistrationNumber"
                                />
                            </v-flex>
                            <v-flex
                                md6
                                sm6
                                xs12
                            >
                                <v-text-field
                                    :error-messages="editEngineSizeErrors"
                                    @blur="$v.editEngineSize.$touch()"
                                    @input="$v.editEngineSize.$touch()"
                                    label="Engine Size"
                                    max="5"
                                    min="0"

                                    step="0.1"
                                    type="number"
                                    v-model="editEngineSize"
                                />
                            </v-flex>
                            <v-flex
                                md6
                                sm6
                                xs12
                            >
                                <v-select
                                    :error-messages="editFuelTypeErrors"
                                    :items="fuelTypeList"
                                    @blur="$v.editFuelType.$touch()"

                                    @input="$v.editFuelType.$touch()"
                                    label="Fuel Type"
                                    v-model="editFuelType"
                                />
                            </v-flex>
                            <v-flex
                                md6
                                sm6
                                xs12
                            >
                                <v-text-field
                                    :error-messages="editMileageRateErrors"
                                    @blur="$v.editMileageRate.$touch()"
                                    @input="$v.editMileageRate.$touch()"
                                    label="Mileage Rate"
                                    max="20"
                                    min="0"
                                    step="0.1"
                                    type="number"
                                    v-model="editMileageRate"
                                />
                            </v-flex>
                            <v-flex
                                md6
                                sm6
                                xs12
                            >
                                <v-text-field
                                    :error-messages="editVatMileageErrors"
                                    @blur="$v.editVatMileage.$touch()"
                                    @input="$v.editVatMileage.$touch()"
                                    label="Mileage VAT"
                                    max="20"

                                    min="0"
                                    type="number"
                                    v-model="editVatMileage"
                                />
                            </v-flex>
                            <v-flex
                                md6
                                sm6
                                xs12
                            >
                                <v-select
                                    :error-messages="editOwnershipTypeErrors"
                                    :items="ownershipTypeList"
                                    @blur="$v.editOwnershipType.$touch()"

                                    @input="$v.editOwnershipType.$touch()"
                                    label="Ownership Type"
                                    v-model="editOwnershipType"
                                />
                            </v-flex>

                            <v-flex
                                md6
                                sm6
                                xs12
                            >
                                <v-menu
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    min-width="290px"
                                    offset-y
                                    transition="scale-transition"

                                    v-model="startDateMenu"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            :value="editStartDate"
                                            label="Start Date"
                                            prepend-icon="event"
                                            readonly
                                            slot="activator"
                                            v-on="on"
                                        />
                                    </template>
                                    <v-date-picker
                                        @input="startDateMenu = false"
                                        no-title
                                        scrollable
                                        v-model="editStartDate"
                                    />
                                </v-menu>
                            </v-flex>

                            <v-flex
                                md6
                                sm6
                                xs12
                            >
                                <v-select
                                    :error-messages="editIsCurrentErrors"
                                    :items="[{Id: true, name: 'Current'}, {Id: false, name: 'Not Current'}]"
                                    @blur="$v.editIsCurrent.$touch()"
                                    @input="$v.editIsCurrent.$touch()"
                                    item-text="name"

                                    item-value="Id"
                                    label="Filter by Current"
                                    v-model="editIsCurrent"
                                />
                            </v-flex>

                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-text-field
                                    label="Comments"
                                    v-model="editComments"
                                />
                                
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        @click="saveEditItemAndCloseDialog"
                        color="green"
                        text
                    >
                        Save
                    </v-btn>
                    <v-btn
                        @click="closeEditItem"
                        color="red darken-1"
                        text
                    >
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from "vuex";
    import EditTableFunctions from '../editTableFunctions';

    import {LOAD_PERSON_VEHICLE_TO_EDIT, RESET_DEFAULT_PERSON_VEHICLE_TO_EDIT, TOGGLE_EDIT_PERSON_VEHICLE_DIALOG, UPDATE_EDIT_PERSON_VEHICLE_FIELD} from "@/store/person_vehicle/mutations";
    import {FETCH_PERSON_VEHICLE_LIST, SAVE_EDITED_PERSON_VEHICLE} from "@/store/person_vehicle/actions.js";
    import {required,} from 'vuelidate/lib/validators'

    export default {
        name: "EditPersonVehicleDialog",

        validations: {
            editRegistrationNumber: {required},
            editEngineSize: {required},
            editFuelType: {required},
            editMileageRate: {required},
            editVatMileage: {required},
            editOwnershipType: {required},
            editStartDate: {required},
            editIsCurrent: {required},
        },

        components: {},

        mixins: [
            EditTableFunctions,
        ],
        data() {
            return {
                // Required for editTableFunctions
                idName: 'feedbackId',
                startDateMenu: false,
            }
        },

        computed: {
            editPersonVehicleDialog: {
                get() {
                    return this.$store.state.person_employment.editPersonVehicleDialog;
                },
            },
            editPersonVehicleDialogErrors() {
                const errors = [];
                if (!this.$v.editPersonVehicleDialog.$dirty) return errors;
                !this.$v.editPersonVehicleDialog.required && errors.push('required.');
                return errors
            },
            editRegistrationNumber: {
                get() {
                    return this.$store.state.person_vehicle.editPersonVehicle.registrationNumber;
                },
                set(value) {
                    this.updateValue('registrationNumber', value);
                },
            },
            editRegistrationNumberErrors() {
                const errors = [];
                if (!this.$v.editRegistrationNumber.$dirty) return errors;
                !this.$v.editRegistrationNumber.required && errors.push('required.');
                return errors
            },
            editEngineSize: {
                get() {
                    return this.$store.state.person_vehicle.editPersonVehicle.engineSize;
                },
                set(value) {
                    this.updateValue('engineSize', value);
                },
            },
            editEngineSizeErrors() {
                const errors = [];
                if (!this.$v.editEngineSize.$dirty) return errors;
                !this.$v.editEngineSize.required && errors.push('required.');
                return errors
            },
            editFuelType: {
                get() {
                    return this.$store.state.person_vehicle.editPersonVehicle.fuelType;
                },
                set(value) {
                    this.updateValue('fuelType', value);
                },
            },
            editFuelTypeErrors() {
                const errors = [];
                if (!this.$v.editFuelType.$dirty) return errors;
                !this.$v.editFuelType.required && errors.push('required.');
                return errors
            },
            editMileageRate: {
                get() {
                    return this.$store.state.person_vehicle.editPersonVehicle.mileageRate;
                },
                set(value) {
                    this.updateValue('mileageRate', value);
                },
            },
            editMileageRateErrors() {
                const errors = [];
                if (!this.$v.editMileageRate.$dirty) return errors;
                !this.$v.editMileageRate.required && errors.push('required.');
                return errors
            },
            editVatMileage: {
                get() {
                    return this.$store.state.person_vehicle.editPersonVehicle.vatMileage;
                },
                set(value) {
                    this.updateValue('vatMileage', value);
                },
            },
            editVatMileageErrors() {
                const errors = [];
                if (!this.$v.editVatMileage.$dirty) return errors;
                !this.$v.editVatMileage.required && errors.push('required.');
                return errors
            },

            editOwnershipType: {
                get() {
                    return this.$store.state.person_vehicle.editPersonVehicle.ownershipType;
                },
                set(value) {
                    this.updateValue('ownershipType', value);
                },
            },
            editOwnershipTypeErrors() {
                const errors = [];
                if (!this.$v.editOwnershipType.$dirty) return errors;
                !this.$v.editOwnershipType.required && errors.push('required.');
                return errors
            },
            editStartDate: {
                get() {
                    return this.$options.filters.formatDate(this.$store.state.person_vehicle.editPersonVehicle.startDate);
                },
                set(value) {
                    this.updateValue('startDate', value);
                },
            },
            editStartDateErrors() {
                const errors = [];
                if (!this.$v.editStartDate.$dirty) return errors;
                !this.$v.editStartDate.required && errors.push('required.');
                return errors
            },
            editIsCurrent: {
                get() {
                    return this.$store.state.person_vehicle.editPersonVehicle.isCurrent;
                },
                set(value) {
                    this.updateValue('isCurrent', value);
                },
            },
            editIsCurrentErrors() {
                const errors = [];
                if (!this.$v.editIsCurrent.$dirty) return errors;
                !this.$v.editIsCurrent.required && errors.push('required.');
                return errors
            },
            editComments: {
                get() {
                    return this.$store.state.person_vehicle.editPersonVehicle.comments;
                },
                set(value) {
                    this.updateValue('comments', value);
                },
            },
            ...mapGetters(
            [
                "editPersonVehicleDialog",
                "fiscalYearList",
                "fuelTypeList",
                "mileageCurrencyItems",
                "ownershipTypeList"
            ]
            ),
        },

        methods: {
            ...mapActions({
                fetchItem: FETCH_PERSON_VEHICLE_LIST,
                updateTableItemRecord: SAVE_EDITED_PERSON_VEHICLE,
                // saveNewTableItemRecord: '',
                // deleteTableItem: '',
            }),

            ...mapMutations({
                toggleEditDialog: TOGGLE_EDIT_PERSON_VEHICLE_DIALOG,
                loadTableItemToEdit: LOAD_PERSON_VEHICLE_TO_EDIT,
                updateTableItemToEdit: UPDATE_EDIT_PERSON_VEHICLE_FIELD,
                resetEditItemToDefault: RESET_DEFAULT_PERSON_VEHICLE_TO_EDIT,
            }),

        },

    }
</script>

<style scoped>
</style>
